import { Autocomplete, TextField } from "@mui/material";
import type { FieldError } from "react-hook-form";
import type { StrandAsset } from "../../models/StrandAsset";

interface StrandAssetAutocompleteProps {
  assets: StrandAsset[];
  value: number | null;
  onChange: (value: number | null) => void;
  fieldError?: FieldError;
  disabled?: boolean;
}

export const StrandAssetAutocomplete = ({
  assets,
  value,
  onChange,
  fieldError,
  disabled = false,
}: StrandAssetAutocompleteProps) => {
  const selectedValue = assets.find((asset) => asset.AssetId === value) ?? null;

  return (
    <Autocomplete
      clearOnEscape
      options={assets}
      getOptionLabel={(option) => option.AssetName}
      value={selectedValue}
      onChange={(_event, newValue) => onChange(newValue?.AssetId ?? null)}
      disabled={disabled}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Strand"
          variant="outlined"
          fullWidth
          size="small"
          error={!!fieldError}
          helperText={fieldError?.message}
        />
      )}
    />
  );
};
